import dayjs from "dayjs";
import { actSubjects } from "../actprep-ui/constants/program";
import { filterTypes } from "../actprep-ui/constants/ui";
import { capitalize } from "../actprep-ui/utils/formatting";

export const goodNewsFilters = [
  {
    field: "start_date",
    type: filterTypes.DATE_PICKER,
    props: {
      label: "Week Start Date",
      default: dayjs(),
    },
  },
  {
    field: "quiz_average__gte",
    type: filterTypes.RADIO_GROUP,
    props: {
      label: "Quiz Average",
      options: [
        {
          label: "All",
          value: "",
        },
        {
          label: "80+",
          value: 80,
        },
      ],
    },
  },
  {
    group: "Student Info",
    field: "student__organization_id__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "Organization",
      label: "Organization",
      multiple: true,
    },
  },
  {
    group: "Student Info",
    field: "current_team__in",
    type: filterTypes.API_AUTOCOMPLETE,
    props: {
      apiUrl: "/api/coaching/teams/autocomplete/",
      multiple: true,
      label: "Team",
    },
  },
];
export const masterSheetFilters = [
  {
    group: "Coaching Info",
    field: "coaching_layer",
    type: filterTypes.SELECT,
    props: {
      label: "Coaching Layer",
      default: "assistant",
      options: [
        {
          label: "Lead Coach",
          value: "lead",
        },
        {
          label: "Academic Coach",
          value: "academic",
        },
        {
          label: "Assistant Coach",
          value: "assistant",
        },
      ],
    },
  },
  {
    group: "Week Info",
    field: "start_date",
    type: filterTypes.DATE_PICKER,
    props: {
      label: "Week Start Date",
      default: dayjs().add(-1 * dayjs().day(), "day"),
    },
  },
];
export const accountabilitySheetFilters = [
  {
    group: "Week Info",
    field: "start_date",
    type: filterTypes.DATE_PICKER,
    props: {
      label: "Week Start Date",
      default: dayjs().add(-1 * dayjs().day(), "day"),
    },
  },
  {
    group: "Week Info",
    field: "in_the_game",
    type: filterTypes.RADIO_GROUP,
    props: {
      label: "In the game",
      options: [
        {
          label: "All",
          value: "",
          default: true,
        },
        {
          label: "Yes",
          value: true,
        },
        {
          label: "No",
          value: false,
        },
      ],
    },
  },
  {
    group: "Week Info",
    field: "is_hours_volunteer",
    type: filterTypes.RADIO_GROUP,
    props: {
      label: "Hours Volunteer",
      options: [
        {
          label: "All",
          value: "",
          default: true,
        },
        {
          label: "Yes",
          value: true,
        },
        {
          label: "No",
          value: false,
        },
      ],
    },
  },
  {
    group: "Student Info",
    field: "show_on_good_news",
    type: filterTypes.RADIO_GROUP,
    props: {
      label: "Show on Good News",
      options: [
        {
          label: "All",
          value: "",
          default: true,
        },
        {
          label: "Yes",
          value: true,
        },
        {
          label: "No",
          value: false,
        },
      ],
    },
  },
  {
    group: "Student Info",
    field: "seat_type__icontains",
    type: filterTypes.RADIO_GROUP,
    props: {
      label: "Seat Type",
      options: [
        {
          label: "All",
          value: "",
          default: true,
        },
        {
          label: "Online",
          value: "online",
        },
        {
          label: "Physical",
          value: "physical",
        },
        {
          label: "One-on-One",
          value: "one-on-one",
        },
      ],
    },
  },
  {
    group: "Student Info",
    field: "organization_id__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "Organization",
      label: "Organization",
      multiple: true,
    },
  },
  {
    group: "Student Info",
    field: "cohort_id__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "Cohort",
      label: "Cohort",
      multiple: true,
    },
  },
  {
    group: "Student Info",
    field: "current_team__in",
    type: filterTypes.API_AUTOCOMPLETE,
    props: {
      apiUrl: "/api/coaching/teams/autocomplete/",
      multiple: true,
      label: "Team",
    },
  },
  {
    group: "Student Info",
    field: "current_assistant_coach_id__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "CoachProfile",
      label: "Assistant Coach",
      multiple: true,
      defaultParams: {
        role_assignments__role__in: ["Assistant Coach"],
        is_active: true,
      }
    }
  },
  {
    group: "Student Info",
    field: "school_id__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "School",
      label: "School",
      multiple: true,
    },
  },
];

export const enrollmentProcessingFilters = [
  {
    group: "Enrollment Info",
    field: "is_processed",
    type: filterTypes.RADIO_GROUP,
    props: {
      label: "Processing Status",
      options: [
        {
          label: "All",
          value: "",
          default: true,
        },
        {
          label: "Processed",
          value: true,
        },
        {
          label: "Unprocessed",
          value: false,
        },
      ],
    },
  },
  {
    group: "Enrollment Info",
    field: "enrollment_completed",
    type: filterTypes.RADIO_GROUP,
    props: {
      label: "Enrollment Status",
      options: [
        {
          label: "All",
          value: "",
          default: true,
        },
        {
          label: "Complete",
          value: true,
        },
        {
          label: "Incomplete",
          value: false,
        },
      ],
    },
  },
  {
    group: "Program Info",
    field: "ordered_programs__start_date",
    type: filterTypes.DATE_PICKER,
    props: {
      label: "Program Start Date",
    },
  },
  {
    group: "Program Info",
    field: "ordered_programs__program__uuid__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "Program",
      label: "Program",
      multiple: true,
    },
  },
  {
    group: "Student Info",
    field: "organization_id__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "Organization",
      label: "Organization",
      multiple: true,
    },
  },
  {
    group: "Student Info",
    field: "cohort_id__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "Cohort",
      label: "Cohort",
      multiple: true,
    },
  },
  {
    group: "Student Info",
    field: "current_team__in",
    type: filterTypes.API_AUTOCOMPLETE,
    props: {
      apiUrl: "/api/coaching/teams/autocomplete/",
      multiple: true,
      label: "Team",
    },
  },
];

export const challengesFilters = [
  {
    field: "test_id__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "Test",
      label: "Test",
      multiple: true,
    },
  },
  {
    field: "subject",
    type: filterTypes.SELECT,
    props: {
      label: "Subject",
      options: [
        {
          label: "All",
          value: "",
          default: true,
        },
        ...actSubjects.map((subject) => ({
          value: subject,
          label: capitalize(subject),
        })),
      ],
    },
  },
];

export const teamManagementFilters = [
  {
    field: "is_active",
    type: filterTypes.RADIO_GROUP,
    props: {
      label: "Coach Status",
      options: [
        {
          label: "All",
          value: "",
          default: true,
        },
        {
          label: "Active",
          value: true,
        },
        {
          label: "Inactive",
          value: false,
        },
      ],
    },
  },
];

export const manageToDoItemsFilters = [
  {
    field: "is_active",
    type: filterTypes.RADIO_GROUP,
    props: {
      label: "Active",
      options: [
        {
          label: "All",
          value: "",
          default: true,
        },
        {
          label: "Yes",
          value: true,
        },
        {
          label: "No",
          value: false,
        },
      ],
    },
  },
  {
    field: "tags__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "Tag",
      label: "Tags",
      multiple: true,
    },
  },
  {
    field: "teams__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "Team",
      label: "Team",
      multiple: true,
    },
  },
  {
    field: "roles__in",
    type: filterTypes.MODEL_AUTOCOMPLETE,
    props: {
      modelName: "Role",
      label: "Role",
      multiple: true,
    },
  },
  {
    group: "Time Range",
    field: "next_occurrence_date__gte",
    type: filterTypes.DATE_PICKER,
    props: {
      label: "Next Occurrence Date (Min)",
    },
  },
  {
    group: "Time Range",
    field: "next_occurrence_date__lte",
    type: filterTypes.DATE_PICKER,
    props: {
      label: "Next Occurrence Date (Max)",
    },
  },
];
